import { SuspenseLoadingView } from 'common/components/SuspenseLoadingView';
import { Outlet } from 'react-router';
import { RSimSessionHistoryTable } from './RSimSessionHistoryTable';
import { ContentBox } from 'common/components/AppLayout/ContentBox.tsx';
import { TableSkeleton } from 'common/components/Table/TableSkeleton.tsx';
import { SessionHistoryErrorBoundary } from 'simInventory/SessionHistory/SessionHistoryErrorBoundary';
import { styled } from '@mui/material/styles';
import { rsimProductDetailsQueries } from 'rSimInventory/Details/utils/rsimProductDetailsQueries.ts';

const RSimSessionHistoryEntryRoot = styled('div', { name: 'RSimHistoryAnalysisContentRoot' })({
  position: 'relative',
});

export const RSimSessionHistoryEntry = () => {
  return (
    <RSimSessionHistoryEntryRoot>
      <SuspenseLoadingView
        loadFallback={
          <ContentBox>
            <TableSkeleton numberOfRows={20} pagination={false} />
          </ContentBox>
        }
        queryKey={rsimProductDetailsQueries.allDetails}
      >
        <SessionHistoryErrorBoundary>
          <RSimSessionHistoryTable />
          <Outlet />
        </SessionHistoryErrorBoundary>
      </SuspenseLoadingView>
    </RSimSessionHistoryEntryRoot>
  );
};
